<div #pageContainer class="w-full">
    <form [formGroup]="searchForm">
        <div class="grid grid-cols-2 gap-2">
            <div class="flex justify-start">
                <div class="w-19 mx-2">
                    <mat-form-field class="w-full">
                        <mat-select formControlName="PageSize">
                            <mat-option [value]="10"> 10 </mat-option>
                            <mat-option [value]="20"> 20 </mat-option>
                            <mat-option [value]="50"> 50 </mat-option>
                            <mat-option [value]="100"> 100 </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <button
                    class="btn btn-outline btn-default dt-download mx-2 group"
                    [matMenuTriggerFor]="downloadMenu"
                >
                    <mat-icon
                        class="text-primary group-hover:text-white"
                        svgIcon="heroicons_solid:arrow-down-tray"
                    ></mat-icon>
                </button>
                <mat-menu #downloadMenu="matMenu">
                    <button
                        mat-menu-item
                        (click)="downloadFieldsSummaryExcel()"
                    >
                        <span>Excel</span>
                    </button>
                </mat-menu>
            </div>
            <div class="flex justify-end">
                <app-single-filter
                    [searchForm]="searchForm"
                    [filterBy]="'Field'"
                    class="text-primary w-64"
                ></app-single-filter>

                <button
                    class="btn btn-primary mx-2"
                    (click)="setPage({ offset: 0 })"
                >
                    Search
                </button>

                <button class="btn btn-outline btn-default" (click)="reset()">
                    Reset
                </button>
                <button
                    class="btn btn-outline btn-default mx-2 group"
                    (click)="setPage({ offset: dt.page.offset})"
                >
                    <mat-icon
                        class="text-primary group-hover:text-white"
                        svgIcon="heroicons_solid:arrow-path"
                    ></mat-icon>
                </button>
            </div>
        </div>
    </form>

    <div class="grid overflow-x-auto">
        <!-- Header -->
        <div
            class="table-cm-field-summary-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
            matSort
            matSortDisableClear
        >
            <div class="border py-8 text-center"></div>

            <div class="border py-8 text-center">No</div>

            <div
                [mat-sort-header]="'fieldLongName'"
                class="flex justify-center border py-8"
            >
                Field Name
            </div>

            <div
                [mat-sort-header]="'pmCompleteness'"
                class="flex justify-center border py-4"
            >
                CM Completeness
            </div>

            <div class="block col-span-6 text-center border pt-4">
                CM Status

                <div class="grid grid-cols-6 text-sm font-bold mt-3">
                    <div class="border text-center py-2">Total Baseline</div>
                    <div class="border text-center py-2">Total Emerging</div>
                    <div class="border text-center py-2">Total General</div>
                    <div class="border text-center py-2">
                        Rectified Baseline
                    </div>
                    <div class="border text-center py-2">
                        Rectified Emerging
                    </div>
                    <div class="border text-center py-2">Rectified General</div>
                </div>
            </div>
        </div>
        <!-- Rows -->
        <ng-container *ngIf="dt.rows.length; else noRecords">
            <ng-container
                *ngFor="let row of dt.rows; let i = index; trackBy: trackByFn;"
            >
                <div
                    class="table-cm-field-summary-grid grid items-center border-b"
                    [ngClass]="{'bg-primary-100': i % 2 }"
                >
                    <!-- Expand Icon -->
                    <button
                        class="py-4 text-center cursor-pointer w-full flex justify-center items-center"
                        (click)="toggleExpandRow(row)"
                    >
                        <mat-icon
                            [svgIcon]="row.expanded ? 'heroicons_mini:minus' : 'heroicons_mini:plus'"
                        ></mat-icon>
                    </button>

                    <!-- No -->
                    <div class="py-4 text-center">
                        {{startingIndex + i + 1}}.
                    </div>

                    <!-- Field Long Name -->
                    <div class="flex truncate justify-center">
                        {{ row.fieldLongName }}
                    </div>

                    <!-- CM Completeness Percentage  -->
                    <div class="flex justify-center px-4">
                        <div class="progress-container">
                            <div
                                class="progress-bar"
                                [style.width.%]="row.cmCompleteness"
                            >
                                {{ row.cmCompleteness }}%
                            </div>
                        </div>
                    </div>

                    <!-- CM Status -->
                    <div class="block text-center">{{ row.baseline }}</div>
                    <div class="block text-center">{{ row.emerging }}</div>
                    <div class="block text-center">{{ row.general }}</div>
                    <div class="block text-center">
                        {{ row.rectifiedBaseline }}
                    </div>
                    <div class="block text-center">
                        {{ row.rectifiedEmerging }}
                    </div>
                    <div class="block text-center">
                        {{ row.rectifiedGeneral }}
                    </div>
                </div>

                <!-- Expand Row -->
                <div
                    *ngIf="row.expanded"
                    class="table-cm-field-summary-grid grid items-center border-b"
                    [ngClass]="{'bg-primary-100': i % 2 }"
                >
                    <ng-container
                        *ngFor="let rowChild of row.list; let i = index; trackBy: trackByFn;"
                    >
                        <div class="my-5"></div>
                        <div></div>

                        <!-- Field Long Name -->
                        <div class="flex truncate justify-center">
                            {{ rowChild.platformLongName }}
                        </div>

                        <!-- PM Completeness Percentage  -->
                        <div class="flex justify-center px-4">
                            <div class="progress-container">
                                <div
                                    class="progress-bar"
                                    [style.width.%]="row.cmCompleteness"
                                >
                                    {{ rowChild.cmCompleteness }}%
                                </div>
                            </div>
                        </div>

                        <!-- CM Status -->
                        <div class="block text-center">
                            {{ rowChild.baseline }}
                        </div>
                        <div class="block text-center">
                            {{ rowChild.emerging }}
                        </div>
                        <div class="block text-center">
                            {{ rowChild.general }}
                        </div>
                        <div class="block text-center">
                            {{ rowChild.rectifiedBaseline }}
                        </div>
                        <div class="block text-center">
                            {{ rowChild.rectifiedEmerging }}
                        </div>
                        <div class="block text-center">
                            {{ rowChild.rectifiedGeneral }}
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </ng-container>

        <ng-template #noRecords>
            <div
                class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center"
            >
                There are no Records registered!
            </div>
        </ng-template>
    </div>

    <div
        class="flex justify-between inset-x-0 bottom-0 border-b border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent"
    >
        <div class="content-center px-3">
            {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ?
            'total' : 'totals' }}
        </div>

        <mat-paginator
            class="bg-gray-50"
            [ngClass]="{'pointer-events-none': isLoading}"
            [length]="dt.page?.totalRecords"
            [pageIndex]="dt.page.offset"
            [pageSize]="dt.page.size"
            [hidePageSize]="true"
            [showFirstLastButtons]="true"
        >
        </mat-paginator>
    </div>
</div>
